import { wxInstance } from './multiRequest'

// WX_TOKEN相关的API接口
// 这些接口使用baseWebIP域名和WX_TOKEN

// 查询全国组别表单信息列表
export function queryNationalGroupFormInfoList (params) {
  return wxInstance({
    url: '/slabForm/queryNationalGroupFormInfoList',
    method: 'GET',
    params,
    showLoading: false
  })
}

// 保存答案结果
export function saveNationalAnswerResult (data) {
  return wxInstance({
    url: '/slabForm/saveNationalAnswerResult',
    method: 'POST',
    data
  })
}

// 查询考场和比赛号码
export function selectByRoomAndNum (params) {
  return wxInstance({
    url: '/common/examinationUser/selectByRoomAndNum',
    method: 'GET',
    params
  })
}

// 保存签到状态
export function saveSignStatus (data) {
  return wxInstance({
    url: '/common/examinationUser/saveIsLogin',
    method: 'POST',
    data
  })
}

// 查询是否有答题记录
export function selectFormAnswerById (params) {
  return wxInstance({
    url: '/slabForm/selectFormAnswerById',
    method: 'GET',
    params
  })
}
